import { ComponentProps } from 'react'
import { Badge, Tooltip } from '@radix-ui/themes'
import { PamPlayerVerificationStatus } from '@Generated/back-office-client/src'
import { getStatusDisplay } from './pam-verification-status-display'

export type PamVerificationStatusBadgeProps = {
  status: PamPlayerVerificationStatus
  size?: ComponentProps<typeof Badge>['size']
}

export const PamVerificationStatusBadge = ({ status, size }: PamVerificationStatusBadgeProps) => {
  const display = getStatusDisplay(status)
  return (
    <Tooltip content={display.tooltip}>
      <Badge size={size} color={display.color} variant="soft">
        {display.label}
      </Badge>
    </Tooltip>
  )
}
